import React from 'react';
import cx from 'classnames';

const TextField = React.forwardRef(({ type = 'text', placeholder, className, onChange, onFocus, value = '', onKeyUp }, ref) => (
  <input
    className={cx(className)}
    type={type}
    placeholder={placeholder}
    onChange={onChange}
    onFocus={onFocus}
    onKeyUp={onKeyUp}
    value={value}
    ref={ref}
  />
))

export default TextField;
